import Svg from 'components/utilities/svg'

const EndmillAltIcon = ({ ...props }) => (
  <Svg viewBox="0 0 12 12" {...props}>
    <title>Endmill Icon</title>
    <path d="M8.1 10.9a.5.5 0 0 1-.5.5H5.108a7.939 7.939 0 0 0 2.66-1.607c.116-.108.227-.22.332-.333v1.44ZM8 4a.1.1 0 0 1 .1.1v4.056c-.243.372-.53.73-.876 1.051-1.064.988-2.337 1.491-3.322 1.723L3.9 10.9V8.041A5.611 5.611 0 0 0 6.13 6.5H7a.1.1 0 0 0 .1-.1V4H8ZM4.9 6.568a4.727 4.727 0 0 1-1 .61V4.1A.1.1 0 0 1 4 4h.9v2.568ZM10.243 2.332A1.6 1.6 0 0 1 8.734 3.4H3.268a1.6 1.6 0 0 1-1.51-1.068L1.2.75h1.273l.418 1.183c.056.16.208.267.378.267h5.466a.4.4 0 0 0 .377-.267L9.53.75h1.273l-.559 1.582Z" />
  </Svg>
)

EndmillAltIcon.displayName = 'Endmill'

export default EndmillAltIcon
